import { registerCommand } from "./registry.ts";
import { nlsSchema } from "../schema.ts";

// --- Link ---
registerCommand({
  name: "link",
  aliases: ["ln"],
  description: "Create a link from selection to target",
  args: [
    {
      name: "target",
      type: "text",
      prompt: "Link to (docId:sid or docId):",
    },
  ],
  execute(ctx, args) {
    const view = ctx.editorView;
    if (!view) return;

    const { from, to } = view.state.selection;
    if (from === to) return; // No selection

    const target = args.target;
    if (!target) return;

    // Parse "docId:sid" or just "docId"
    const parts = target.split(":");
    const documentId = parts[0]!;
    const sid = parts[1] || undefined;

    const mark = nlsSchema.marks.nls_link!.create({
      documentId,
      sid: sid ?? null,
      viewspec: null,
    });

    const tr = view.state.tr.addMark(from, to, mark);
    view.dispatch(tr);
  },
});

// --- Unlink ---
registerCommand({
  name: "unlink",
  aliases: ["ul"],
  description: "Remove link at cursor",
  args: [],
  execute(ctx) {
    const view = ctx.editorView;
    if (!view) return;

    const { from, to } = view.state.selection;
    const markType = nlsSchema.marks.nls_link!;

    if (from === to) {
      // No selection — remove link mark at cursor position
      const $pos = view.state.doc.resolve(from);
      const marks = $pos.marks();
      const linkMark = marks.find((m) => m.type === markType);
      if (linkMark) {
        // Find the range of the link mark
        const start = $pos.start();
        const end = $pos.end();
        const tr = view.state.tr.removeMark(start, end, markType);
        view.dispatch(tr);
      }
    } else {
      const tr = view.state.tr.removeMark(from, to, markType);
      view.dispatch(tr);
    }
  },
});
